// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operations-row {
  top: 55px;
  width: 100%;
  z-index: 2;
  left: 0px;
  height: 40px;
  box-shadow: none;
  padding: 6px 4px;
  text-align: right;
  padding-right: 0px;
}

.wild {
  top: 48px !important;
}

.operation-row-ext {
  top: 80px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/operations-bar/operations-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,WAAA;EACA,UAAA;EAEA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;;AAEA;EACI,oBAAA;AACJ;;AACA;EACI,oBAAA;AAEJ","sourcesContent":[".operations-row{\r\n    top: 55px;\r\n    width: 100%;\r\n    z-index: 2;\r\n    // background: #fff;\r\n    left: 0px;\r\n    height: 40px;\r\n    box-shadow: none;\r\n    padding: 6px 4px;\r\n    text-align: right;\r\n    padding-right: 0px;\r\n}\r\n.wild{\r\n    top:48px !important;\r\n}\r\n.operation-row-ext{\r\n    top:80px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
